import { render, staticRenderFns } from "./AuctionListingsComponent.vue?vue&type=template&id=b085ce9c&scoped=true&"
import script from "./AuctionListingsComponent.vue?vue&type=script&lang=ts&"
export * from "./AuctionListingsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AuctionListingsComponent.vue?vue&type=style&index=0&id=b085ce9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b085ce9c",
  null
  
)

export default component.exports